// Shared admin utilities used across AdminDashboard and its sub-pages.

// Format a dollar value with K/M suffixes for compact display.
// Returns null for zero/undefined so the caller can conditionally render.
export function fmtVal(v) {
  if (!v) return null;
  if (v >= 1000000) return '$' + (v / 1000000).toFixed(1) + 'M';
  if (v >= 1000)    return '$' + Math.round(v / 1000) + 'K';
  return '$' + Math.round(v);
}

// Status pill component used in admin tables to show count status at a glance.
export function Pill({ status }) {
  /* **not_started is the NEUTRAL badge, not the red one. Corrected 11 September
     2026**, job 27 phase 3. Phase 2 moved every unstarted count off red, per
     the guide's decision 2, and missed this one because it names a CSS class
     rather than a colour token, so nothing the sweep looked for was in it.
     Every "Not started" badge on the cycle screens was still red. */
  const map    = { not_started: 'pill-ns', in_progress: 'pill-sub', submitted: 'pill-ip', /* guide 11.4 */ approved: 'pill-app' };
  // Sentence case, which is what every approved drawing uses and what the
  // four-colour legend beside it already said. Corrected 5 September 2026.
  const labels = { not_started: 'Not started', in_progress: 'In progress', submitted: 'Submitted', approved: 'Approved' };
  return <span className={'pill ' + (map[status] || 'pill-ns')}>{labels[status] || status}</span>;
}
